import React, { Component } from "react";
import SkipLinksChild from "./SkipLinksChild.js";

class SkipLinksBlock extends Component {

  constructor() {
    super();
    this.state = {
      skipLinksOn: false
    };

    /**
     * Contains attribute data for the skip link HTML elements which 
     * are assigned via map() in the render return().
     */
    this.skipLinkData = {
      data: [
        {
          href: "#pageContent",
          sktarget: "#pageContent",
          link_text: "Skip to Main Content",
          aria_label: "Skip to main content link."
        },
        {
          href: "#pageBanner",
          sktarget: "#pageBanner",
          link_text: "Skip to Banner",
          aria_label: "Skip to banner link."
        },
        {
          href: "#footer",
          sktarget: "#footer",
          link_text: "Skip to Main Footer",
          aria_label: "Skip to main Footer link."
        }
      ]
    };

    /**
     * Event Bindings
     * 
     * @method - this.handleSkipLinksOnFocus
     * @method - this.handleSkipLinksOnBlur
     * @method - this.handleSkipLinksOnScroll
     */
    this.handleSkipLinksOnFocus = this.handleSkipLinksOnFocus.bind(this);
    this.handleSkipLinksOnBlur = this.handleSkipLinksOnBlur.bind(this);
    this.handleSkipLinksOnScroll = this.handleSkipLinksOnScroll.bind(this);
  }

  componentDidMount() {
    window.addEventListener("scroll", this.handleSkipLinksOnScroll); // Get scroll event data from the document.
  }

  /**
   * @method handleSkipLinksOnFocus - Shows skip links when they gain focus.
   * 
   * @param {event} - the onFocus event.
   */
  handleSkipLinksOnFocus(event) {
    if (event.type === "focus") {
      if (!this.state.skipLinksOn) {
        this.setState({ skipLinksOn: true });
      }
    }
  }
  /**
   * @method handSkipLinksOnBlur - hides skips links when they lose focus
   * 
   * @param {event} - the onBlur event.
   */
  handleSkipLinksOnBlur(event) {
    if (event.type === "blur") {
      if (this.state.skipLinksOn) {
        this.setState({ skipLinksOn: false });
      }
    }
  }

  /**
   * @method handleSkipLinksOnScroll - hides navigation skip links when the scroll event is triggered.
   * 
   * @param {event} - the onScroll event.
   */
  handleSkipLinksOnScroll() {
    this.setState({ skipLinksOn: false });
  }

  /**
   * Render/ return the JSX skiplinks component.
   */
  render() {
    const skipLinkContainerclass = this.state.skipLinksOn
      ? "skplink-container active"
      : "skplink-container";
    const skipLinkData = this.skipLinkData.data;

    return (
      <div
        id="skplinkContainer"
        onFocus={event => this.handleSkipLinksOnFocus(event)}
        onBlur={event => this.handleSkipLinksOnBlur(event)}
        className={skipLinkContainerclass}
      >
        <ul>
          <li>
            <a href="/" aria-label="Press tab for skip links" />
          </li>
          {skipLinkData.length > 0
            ? skipLinkData.map((skpData, index) => (
              <li key={index}>
                  <SkipLinksChild
                    href={skpData.href}
                    sktarget={skpData.sktarget}
                    link_text={skpData.link_text}
                  />
              </li>
            ))
            : ""}
        </ul>
      </div>
    );
  }
}

export default SkipLinksBlock;
